module.exports = __webpack_public_path__ + "public/files/img/results-ai.83085023.gif";